import { getSectionMessages } from "../../../redux/slices/messages.slice";
import { useAppDispatch, useAppSelector } from "../../../redux/store"
import { MessageSections } from "../../../pages/components/message/message";
import { useEffect, useState } from "react";

export const MessageLoader = ({ sectionName, children }: { sectionName: MessageSections, children: any, }) => {
    const { messageCache } = useAppSelector(state => state.messagesReducer);
    const [isReady, setIsReady] = useState<boolean>(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!messageCache.hasOwnProperty(sectionName)) {
            dispatch(getSectionMessages(sectionName)).then(() => {
                setIsReady(true)
            }
            )
        } else {
            setIsReady(true)
        }
    }, [isReady])

    return isReady ? <>{children}</> : <></>
}